<template>
  <div class="invoice-add-container">
    <b-row>
      <b-col :lg="12">
        <div class="drip-form-container">
          <form @submit.prevent="submitInvoiceDetails" novalidate>
            <div class="drip-form">
              <b-row>
                <b-col>
                  <h3 class="title-slash">
                    {{ $t('invoices.add.titles.shippingDetails') }}
                  </h3>
                </b-col>
              </b-row>
              <b-row>
                <b-col :sm="5" v-if="isIndia">
                  <b-form-group
                    class="dc-group"
                    :class="{
                      'is-invalid': errors.has('shipping_bill_date'),
                      'is-empty': dates.shipping_bill_date === ''
                    }"
                  >
                    <label
                      class="dc-label"
                      :class="{ empty: dates.shipping_bill_date === '' }"
                    >
                      <span>{{
                        $t('invoices.add.helpers.shippingBillDate.label')
                      }}</span>
                    </label>
                    <div class="date-picker position-relative">
                      <date-picker
                        autocomplete="off"
                        name="shipping_bill_date"
                        ref="shippingBillDate"
                        v-model="dates.shipping_bill_date"
                        :placeholder="
                          $t(
                            'invoices.add.helpers.shippingBillDate.placeHolder'
                          )
                        "
                        :config="options"
                        v-validate="'required'"
                        data-vv-as="Shipping bill date"
                      ></date-picker>
                      <span
                        class="action-input"
                        slot="caret"
                        @click="$refs.shippingBillDate.$el.focus()"
                        ><b-icon-calendar-2-event-fill font-scale="0.9"
                      /></span>
                    </div>
                    <span class="error">
                      {{ errors.first('shipping_bill_date') }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col :sm="5" v-if="isIndia">
                  <b-form-group
                    class="dc-group"
                    :class="{
                      'is-invalid': errors.has('shipping_line'),
                      'is-empty': form.shipping_line === ''
                    }"
                  >
                    <label class="dc-label">
                      <span>{{
                        $t('invoices.add.helpers.shippingLine.label')
                      }}</span>
                    </label>
                    <b-form-input
                      name="shipping_line"
                      type="text"
                      :placeholder="
                        $t('invoices.add.helpers.shippingLine.placeHolder')
                      "
                      v-validate="'required'"
                      data-vv-as="Shipping line"
                      v-model="form.shipping_line"
                    ></b-form-input>
                    <span class="error">
                      {{ errors.first('shipping_line') }}
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col :sm="5" v-if="isIndia && apiLoaded && !isIFProduct">
                  <b-form-group
                    class="dc-group"
                    :class="{
                      'is-invalid': errors.has('consignee'),
                      'is-empty': form.consignee === ''
                    }"
                  >
                    <label>
                      <span>{{
                        $t('invoices.add.helpers.consignee.label')
                      }}</span>
                    </label>
                    <b-form-input
                      name="consignee"
                      type="text"
                      :placeholder="
                        $t('invoices.add.helpers.consignee.placeHolder')
                      "
                      v-validate="'required'"
                      data-vv-as="Consignee"
                      v-model="form.consignee"
                    ></b-form-input>
                    <span class="error">
                      {{ errors.first('consignee') }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col :sm="5" v-if="isIFProduct">
                  <b-form-group class="dc-group">
                    <label>
                      <span>{{
                        $t('invoices.add.helpers.customerBuyerName.label')
                      }}</span>
                    </label>
                    <b-form-input
                      name="customer_buyer_name"
                      type="text"
                      :placeholder="
                        $t('invoices.add.helpers.customerBuyerName.placeHolder')
                      "
                      v-model="form.customer_buyer_name"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col :sm="5" v-if="isIndia">
                  <b-form-group
                    class="dc-group"
                    :class="{
                      'is-invalid': errors.has('vessel_name'),
                      'is-empty': form.vessel_name === ''
                    }"
                  >
                    <label>
                      <span>{{
                        $t('invoices.add.helpers.vesselName.label')
                      }}</span>
                    </label>
                    <b-form-input
                      name="vessel_name"
                      type="text"
                      :placeholder="
                        $t('invoices.add.helpers.vesselName.placeHolder')
                      "
                      v-validate="'required'"
                      data-vv-as="Vessel name"
                      v-model="form.vessel_name"
                    ></b-form-input>
                    <span class="error">
                      {{ errors.first('vessel_name') }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col :sm="5">
                  <b-form-group
                    class="dc-group"
                    :class="{
                      'is-invalid': errors.has('user_due_date'),
                      'is-empty': dates.user_due_date === ''
                    }"
                  >
                    <label :class="{ empty: dates.user_due_date === '' }">
                      <span>{{
                        $t('invoices.add.helpers.userDueDate.label')
                      }}</span>
                    </label>
                    <div class="date-picker position-relative">
                      <date-picker
                        autocomplete="off"
                        name="user_due_date"
                        ref="userDueDate"
                        v-model="dates.user_due_date"
                        :placeholder="
                          $t('invoices.add.helpers.userDueDate.placeHolder')
                        "
                        :config="minDate"
                        v-validate="'required'"
                        data-vv-as="Estimated due date"
                      />
                      <span
                        class="action-input"
                        slot="caret"
                        @click="$refs.userDueDate.$el.focus()"
                        ><b-icon-calendar-2-event-fill font-scale="0.9"
                      /></span>
                    </div>
                    <span class="error">
                      {{ errors.first('user_due_date') }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col :sm="5" v-if="isDP">
                  <b-form-group
                    class="dc-group"
                    :class="{
                      'is-invalid': errors.has('container'),
                      'is-empty': form.container === ''
                    }"
                  >
                    <label :class="{ empty: form.container === '' }">
                      <span>{{
                        $t('invoices.add.helpers.containerNo.label')
                      }}</span>
                    </label>
                    <b-form-input
                      name="container"
                      type="text"
                      :placeholder="
                        $t('invoices.add.helpers.containerNo.placeHolder')
                      "
                      v-validate="isDP ? 'required' : ''"
                      data-vv-as="Container number"
                      v-model="form.container"
                    ></b-form-input>
                    <span class="error">
                      {{ errors.first('container') }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col :sm="5" v-if="isDP">
                  <b-form-group
                    class="dc-group"
                    :class="{
                      'is-invalid': errors.has('bl_no'),
                      'is-empty': form.bl_no === ''
                    }"
                  >
                    <label>
                      <span>{{ $t('invoices.add.helpers.blNo.label') }}</span>
                    </label>
                    <b-form-input
                      name="bl_no"
                      type="text"
                      :placeholder="$t('invoices.add.helpers.blNo.placeHolder')"
                      v-validate="isDP ? 'required' : ''"
                      data-vv-as="BL no"
                      v-model="form.bl_no"
                    ></b-form-input>
                    <span class="error">
                      {{ errors.first('bl_no') }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col :sm="5" v-if="isDP">
                  <b-form-group
                    class="dc-group"
                    :class="{
                      'is-invalid': errors.has('bl_date'),
                      'is-empty': dates.bl_date === ''
                    }"
                  >
                    <label :class="{ empty: dates.bl_date === '' }">
                      <span>{{ $t('invoices.add.helpers.blDate.label') }}</span>
                    </label>
                    <div class="date-picker position-relative">
                      <date-picker
                        name="bl_date"
                        v-model="dates.bl_date"
                        ref="blDate"
                        :placeholder="
                          $t('invoices.add.helpers.blDate.placeHolder')
                        "
                        v-validate="isDP ? 'required' : ''"
                        data-vv-as="BL date"
                        :config="options"
                      />
                      <span
                        class="action-input"
                        slot="caret"
                        @click="$refs.blDate.$el.focus()"
                        ><b-icon-calendar-2-event-fill font-scale="0.9"
                      /></span>
                    </div>
                    <span class="error">
                      {{ errors.first('bl_date') }}
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <div class="drip-form-actions">
              <b-row>
                <b-col>
                  <b-link
                    class="mr-3 btn btn-light-purple"
                    :loading="infoSaving"
                    @click.prevent="navigateBack"
                  >
                    <span class="d-md-inline-block d-none">{{
                      $t('invoices.add.actions.back')
                    }}</span>
                    <b-icon-chevron-left class="d-md-none" />
                  </b-link>
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col>
                  <b-link class="mr-3" @click="saveDraft()">
                    {{ $t('invoices.add.actions.save') }}
                  </b-link>
                  <form-button
                    :loading="infoSaving"
                    type="submit"
                    variant="secondary"
                  >
                    <span class="d-md-inline-block d-none">{{
                      $t('invoices.add.actions.next')
                    }}</span>
                    <b-icon-chevron-right class="d-md-none" />
                  </form-button>
                </b-col>
              </b-row>
            </div>
          </form>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import FormButton from '@/components/common/FormButton'
import DatePicker from 'vue-bootstrap-datetimepicker'
import { mapActions } from 'vuex'
import { addInvoiceMixin } from '@/mixins/Invoice'
import invoiceService from '@/services/invoice'
import accountsService from '@/services/accounts'

export default {
  props: ['saving', 'exporterData', 'form'],
  data() {
    return {
      infoSaving: this.saving,
      nextStep: 'funding-details',
      prevStep: 'basic-info',
      dates: {
        user_due_date: '',
        shipping_bill_date: '',
        bl_date: ''
      },
      productValue: null,
      isIFProduct: false,
      apiLoaded: false
    }
  },
  created() {
    this.loadInvoice()
  },
  mounted() {
    this.$mpTrack(`Add Invoice - Shipping Step Loaded`)
    accountsService
      .fetchBusinessAccount({
        include: ['parent_user', 'plan']
      })
      .then((res) => {
        this.productValue = res.data.plan.product_value
      })
      .catch()
  },
  computed: {
    isIndia() {
      return this.$store.state.account.country === 'India'
    },
    selectedImporter() {
      return this.getBuyerFromId(this.form.importer_user_id)
    },
    isDP() {
      return this.selectedImporter ? this.selectedImporter['docs_cma?'] : false
    },
    options() {
      return {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        locale: this.$i18n.locale === 'es-MX' ? 'es' : 'en'
      }
    },
    minDate() {
      return {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        minDate: this.$getCurrentDate('YYYY-MM-DD'),
        locale: this.$i18n.locale === 'es-MX' ? 'es' : 'en'
      }
    }
  },
  methods: {
    navigateBack() {
      this.$mpTrack(`Add Invoice - navigate back to ${this.prevStep}`)
      this.navigate('invoicesAdd', this.$route.params.id, this.prevStep)
    },
    submitInvoiceDetails(save) {
      this.$mpTrack('Add Invoice - Shipping Details Next Clicked')
      this.$validator.validate().then((result) => {
        if (result) {
          this.addInvoiceDetails(save)
        } else {
          this.$mpTrack(
            'Add Invoice - shipping validation error - mandatory fields not filled'
          )
        }
      })
    },
    addInvoiceDetails() {
      this.$mpTrack('Add Invoice - Shipping Details Validated')
      this.infoSaving = true
      this.setDates()
      this.form.repayment = this.$formatDate(
        this.$dayjs(this.dates.user_due_date, this.options.format),
        'DD-MM-YYYY'
      )
      this.form.value = this.calculatedValue
      this.form.stage = 'draft'
      return invoiceService
        .updateInvoices(this.$route.params.id, {
          invoice: this.form
        })
        .then(() => {
          this.infoSaving = false
          this.setFormData(this.form)
          this.setStep(this.nextStep)
          this.navigate('invoicesAdd', this.$route.params.id, this.nextStep)
          this.$mpTrack('Add Invoice - Shipping Details Added')
        })
        .catch((e) => {
          this.$mpTrack('Add Invoice - Shipping Details Error', {
            error: e
          })
          this.infoSaving = false
          if (
            e &&
            e.response &&
            e.response.status === 422 &&
            e.response.data.message.length > 0
          ) {
            this.$validator.errors.add({
              field: 'bl_no',
              msg: e.response.data.message[0]
            })
          }
        })
    },
    saveDraft() {
      this.infoSaving = true
      this.setDates()
      this.form.value = this.calculatedValue
      this.form.stage = 'draft'
      return invoiceService
        .updateInvoices(this.$route.params.id, {
          invoice: this.form
        })
        .then(() => {
          this.infoSaving = false
          this.$mpTrack('Add Invoice - Shipping Details Saved')
          this.navigate('invoices')
        })
        .catch((e) => {
          this.infoSaving = false
          if (
            e &&
            e.response &&
            e.response.status === 422 &&
            e.response.data.message.length > 0
          ) {
            this.$validator.errors.add({
              field: 'bl_no',
              msg: e.response.data.message[0]
            })
          }
        })
    },
    loadInvoice() {
      return invoiceService
        .fetchInvoicesById(this.$route.params.id, {
          include: ['form_data']
        })
        .then((res) => {
          this.apiLoaded = true
          this.isIFProduct = res.data['packing_list?']
          this.setFormData(res.data.form_data)
          this.getDates(res.data.form_data)
          if (res.data['pdc_applicable?']) {
            this.$emit('get-pdc-data')
          }
        })
        .catch((e) => {
          this.apiLoaded = true
        })
    },
    ...mapActions(['setStep', 'setFormData'])
  },
  mixins: [addInvoiceMixin],
  components: {
    FormButton,
    DatePicker
  }
}
</script>
